/**
 * pv-a11y-loox.js — go-live a11y enhancement for the Loox review-rating badge.
 * s302 (#3 Loox empty link). Sibling of pv-a11y-overlays.js / pv-a11y-disclosures.js.
 * Self-contained, dependency-free, idempotent.
 *
 * Loox injects a PDP rating badge as <a href="#looxReviewsFrame"> wrapping a
 * <div class="loox-rating loox-widget"> of pure-visual stars (no text, no aria-label).
 * That makes it a link with NO accessible name (WCAG 2.4.4 / 4.1.2 link-name) — a
 * screen reader announces an empty link. Loox's markup is injected by the app's own
 * JS at runtime and is not editable in theme Liquid, so this patches it additively
 * after Loox renders, WITHOUT touching Loox's code:
 *   - aria-label="Read customer reviews"  → SR announces a meaningful link name
 *
 * Guards:
 *   - only labels an anchor that has NO accessible name yet (skip if Loox or a
 *     future change already provides aria-label or visible text — never clobber).
 *   - MutationObserver (cheap targeted query) because Loox injects the badge
 *     asynchronously after this deferred script runs; it disconnects once the
 *     badge is found+patched, and is hard-bounded by a 15s timeout so it never
 *     runs permanently on non-PDP pages where the badge never appears.
 */
(function () {
  'use strict';
  if (window.__pvA11yLoox) return;
  window.__pvA11yLoox = true;

  var LABEL = 'Read customer reviews';
  var SELECTOR = 'a[href="#looxReviewsFrame"]';

  function hasAccessibleName(a) {
    var al = a.getAttribute('aria-label');
    if (al && al.trim()) return true;
    var lb = a.getAttribute('aria-labelledby');
    if (lb) {
      // resolve the references — a dangling/empty aria-labelledby is NOT a name
      var named = lb.split(/\s+/).some(function (id) {
        var el = id && document.getElementById(id);
        return el && (el.textContent || '').trim();
      });
      if (named) return true;
    }
    if ((a.textContent || '').trim()) return true;
    if ((a.getAttribute('title') || '').trim()) return true;
    return false;
  }

  // Returns true if at least one matching anchor exists (so the observer can stop).
  function patch() {
    var anchors = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < anchors.length; i++) {
      if (!hasAccessibleName(anchors[i])) {
        anchors[i].setAttribute('aria-label', LABEL);
      }
    }
    return anchors.length > 0;
  }

  // The Loox PDP rating badge is product-scoped and rendered once (it does not
  // re-render per variant), so observe only until it appears, patch it, then
  // disconnect. The shim is loaded site-wide but the badge only exists on PDPs,
  // so a hard timeout bounds the observer's lifetime — it can NEVER stay alive
  // permanently on non-PDP pages (collections / home / cart) where the badge
  // never appears.
  if (!patch()) { // not yet in DOM — Loox injects asynchronously
    var mo = new MutationObserver(function () { if (patch()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // Loox injects within a few seconds; 15s is a generous upper bound after
    // which we stop observing regardless (no badge on this page, or Loox failed).
    window.setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
